export default __webpack_public_path__ + "assets/images/g-bg1-before-3953f080.png";